var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeHighlighted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29383",
    "data-name": "Group 29383",
    transform: "translate(-86.999 -262.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(86.999 262.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_11_",
    "data-name": "svgexport-17 (11)",
    transform: "translate(104.28 269.593)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50010",
    "data-name": "Path 50010",
    d: "M134.017,12.2a4.044,4.044,0,0,1-4.036-4.044V4.27a4.036,4.036,0,1,1,8.071,0V8.156A4.044,4.044,0,0,1,134.017,12.2Z",
    transform: "translate(-125.29 -0.218)",
    fill: "#dada3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50011",
    "data-name": "Path 50011",
    d: "M241.808.226V12.2a4.044,4.044,0,0,0,4.036-4.044V4.27A4.044,4.044,0,0,0,241.808.226Z",
    transform: "translate(-233.082 -0.218)",
    fill: "#9dbc29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50012",
    "data-name": "Path 50012",
    d: "M192.32,107.925a.541.541,0,0,0-.54.541v1.65l-.36-.364a.541.541,0,0,0-.768.762l1.128,1.141v10.3a.54.54,0,1,0,1.081,0V108.466A.541.541,0,0,0,192.32,107.925Z",
    transform: "translate(-183.621 -104.03)",
    fill: "#a34f3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50013",
    "data-name": "Path 50013",
    d: "M241.808,107.982v14.573a.54.54,0,0,0,.513-.54V108.522A.54.54,0,0,0,241.808,107.982Z",
    transform: "translate(-233.082 -104.085)",
    fill: "#873f2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50014",
    "data-name": "Path 50014",
    d: "M69.951,393.038a.541.541,0,0,1-.54-.541v-3.332a.54.54,0,1,1,1.081,0V392.5A.541.541,0,0,1,69.951,393.038Z",
    transform: "translate(-66.906 -374.598)",
    fill: "#c86e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50015",
    "data-name": "Path 50015",
    d: "M84.382,388.623v4.415a.541.541,0,0,0,.54-.541v-3.332A.541.541,0,0,0,84.382,388.623Z",
    transform: "translate(-81.337 -374.598)",
    fill: "#a34f3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50016",
    "data-name": "Path 50016",
    d: "M3.974,96.715A2.649,2.649,0,0,1,1.745,94.98a8.451,8.451,0,0,1-.781-3.715c0-2.856,2.471-6.24,2.576-6.383a.54.54,0,0,1,.869,0c.105.143,2.576,3.526,2.576,6.383A8.451,8.451,0,0,1,6.2,94.98a2.649,2.649,0,0,1-2.229,1.735Z",
    transform: "translate(-0.929 -81.608)",
    fill: "#dada3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50017",
    "data-name": "Path 50017",
    d: "M84.817,84.883a.54.54,0,0,0-.435-.22V96.715a2.649,2.649,0,0,0,2.229-1.735,8.451,8.451,0,0,0,.781-3.715C87.392,88.409,84.922,85.025,84.817,84.883Z",
    transform: "translate(-81.337 -81.608)",
    fill: "#9dbc29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50018",
    "data-name": "Path 50018",
    d: "M382.38,4.744a2.388,2.388,0,0,1-2.635-2.989A2.333,2.333,0,0,1,381.416.081a2.385,2.385,0,1,1,.964,4.663Z",
    transform: "translate(-365.964 -0.001)",
    fill: "#ffdd54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50019",
    "data-name": "Path 50019",
    d: "M445.583,0V4.768a2.456,2.456,0,0,0,.337-.023A2.384,2.384,0,0,0,445.583,0Z",
    transform: "translate(-429.503 -0.001)",
    fill: "#ffb454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50020",
    "data-name": "Path 50020",
    d: "M432.678,197.666a.541.541,0,0,1-.54-.541V194.1a.54.54,0,1,1,1.081,0v3.028A.541.541,0,0,1,432.678,197.666Z",
    transform: "translate(-416.543 -186.571)",
    fill: "#ff405c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50021",
    "data-name": "Path 50021",
    d: "M147.671,180.378v-7.124a.181.181,0,0,1,.061-.135l5.751-5.111a.18.18,0,0,1,.239,0l5.751,5.111a.181.181,0,0,1,.061.135v7.124H147.671Z",
    transform: "translate(-142.342 -161.901)",
    fill: "#fff2de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50022",
    "data-name": "Path 50022",
    d: "M317.882,173.119l-5.751-5.111a.18.18,0,0,0-.12-.046v12.416h5.931v-7.124A.181.181,0,0,0,317.882,173.119Z",
    transform: "translate(-300.752 -161.9)",
    fill: "#fde4c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50023",
    "data-name": "Path 50023",
    d: "M190.834,346.578h-3.242v-5.652a.541.541,0,0,1,.54-.541h2.161a.541.541,0,0,1,.54.541Z",
    transform: "translate(-180.822 -328.1)",
    fill: "#a34f3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50024",
    "data-name": "Path 50024",
    d: "M346.654,358h-1.847a.383.383,0,0,1-.382-.383v-1.85a.383.383,0,0,1,.382-.383h1.847a.383.383,0,0,1,.382.383v1.85A.383.383,0,0,1,346.654,358Z",
    transform: "translate(-331.995 -342.559)",
    fill: "#c8ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50025",
    "data-name": "Path 50025",
    d: "M332.606,344.083H330a.541.541,0,0,1-.54-.541v-2.616a.541.541,0,0,1,.54-.541h2.611a.541.541,0,0,1,.54.541v2.616A.541.541,0,0,1,332.606,344.083ZM330.536,343h1.53v-1.533h-1.53Z",
    transform: "translate(-317.566 -328.1)",
    fill: "#a34f3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50026",
    "data-name": "Path 50026",
    d: "M126.843,164.948a.537.537,0,0,1-.358-.136l-6.282-5.584-6.282,5.584a.541.541,0,0,1-.717-.81l6.641-5.9a.54.54,0,0,1,.717,0L127.2,164a.541.541,0,0,1-.359.946Z",
    transform: "translate(-108.943 -152.262)",
    fill: "#ff405c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50027",
    "data-name": "Path 50027",
    d: "M319.012,164l-6.641-5.9a.538.538,0,0,0-.359-.136v1.265l6.282,5.584a.541.541,0,0,0,.717-.81Z",
    transform: "translate(-300.752 -152.261)",
    fill: "#e20059"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50028",
    "data-name": "Path 50028",
    d: "M17.938,482.9H.541a.551.551,0,0,1-.54-.548.541.541,0,0,1,.54-.541h17.4a.541.541,0,0,1,.54.541.551.551,0,0,1-.54.548Z",
    transform: "translate(-0.001 -464.422)",
    fill: "#dada3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50029",
    "data-name": "Path 50029",
    d: "M264.721,481.81h-8.7v1.09h8.7a.551.551,0,0,0,.54-.548A.541.541,0,0,0,264.721,481.81Z",
    transform: "translate(-246.785 -464.422)",
    fill: "#9dbc29"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeHighlighted);
export default __webpack_public_path__ + "static/media/HomeHighlighted.a2f649fe3ed4d05dd58076fcb8109633.svg";
export { ForwardRef as ReactComponent };